<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1878 13.3555C12.3406 13.5082 12.5281 13.5846 12.7503 13.5846C12.9725 13.5846 13.167 13.5013 13.3337 13.3346C13.4864 13.1819 13.5628 12.9874 13.5628 12.7513C13.5628 12.5152 13.4864 12.3207 13.3337 12.168L10.8337 9.66797V6.64714C10.8337 6.41102 10.7539 6.21658 10.5945 6.0638C10.4345 5.91102 10.2364 5.83464 10.0003 5.83464C9.76421 5.83464 9.56644 5.91436 9.40699 6.0738C9.24699 6.2338 9.16699 6.43186 9.16699 6.66797V9.98047C9.16699 10.0916 9.18783 10.1991 9.22949 10.303C9.27116 10.4074 9.33366 10.5013 9.41699 10.5846L12.1878 13.3555ZM10.0003 18.3346C8.84755 18.3346 7.76421 18.1157 6.75033 17.678C5.73644 17.2407 4.85449 16.6471 4.10449 15.8971C3.35449 15.1471 2.76088 14.2652 2.32366 13.2513C1.88588 12.2374 1.66699 11.1541 1.66699 10.0013C1.66699 8.84852 1.88588 7.76519 2.32366 6.7513C2.76088 5.73741 3.35449 4.85547 4.10449 4.10547C4.85449 3.35547 5.73644 2.76158 6.75033 2.3238C7.76421 1.88658 8.84755 1.66797 10.0003 1.66797C11.1531 1.66797 12.2364 1.88658 13.2503 2.3238C14.2642 2.76158 15.1462 3.35547 15.8962 4.10547C16.6462 4.85547 17.2398 5.73741 17.677 6.7513C18.1148 7.76519 18.3337 8.84852 18.3337 10.0013C18.3337 11.1541 18.1148 12.2374 17.677 13.2513C17.2398 14.2652 16.6462 15.1471 15.8962 15.8971C15.1462 16.6471 14.2642 17.2407 13.2503 17.678C12.2364 18.1157 11.1531 18.3346 10.0003 18.3346ZM10.0003 16.668C11.8475 16.668 13.4206 16.0188 14.7195 14.7205C16.0178 13.4216 16.667 11.8485 16.667 10.0013C16.667 8.15408 16.0178 6.58102 14.7195 5.28214C13.4206 3.9838 11.8475 3.33464 10.0003 3.33464C8.1531 3.33464 6.58033 3.9838 5.28199 5.28214C3.9831 6.58102 3.33366 8.15408 3.33366 10.0013C3.33366 11.8485 3.9831 13.4216 5.28199 14.7205C6.58033 16.0188 8.1531 16.668 10.0003 16.668Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBookingTime",
  props: {
    color: {
      type: String,
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
